<script setup lang="ts">
import ContentMaxWidth from "@/components/ContentMaxWidth.vue";
</script>

<template>
    <footer class="bg-brand p-8">
        <ContentMaxWidth :width="800">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                    <h2 class="font-bold text-lg mb-2">Poslednik</h2>
                    Karosserie und Lack GmbH <br />
                    Kameruner Str. 32<br />
                    Lage-Müssen 32791<br /><br />

                    <strong>Phone</strong> 0 52 32.97790<br />
                    <strong>Email</strong> info@poslednik.de<br />
                    <strong>Geschäftsführer</strong> Bart Bartels, Nico
                    Hilderink
                </div>

                <div>
                    <h2 class="font-bold text-lg">Unsere Öffnungszeiten</h2>
                    <strong>Montag - Freitag</strong> 7.30 - 17.30 Uhr<br />
                    Oder nach Vereinbarung<br /><br />

                    <strong>Ust-ID-Nr.</strong> DE312720750<br />
                </div>
            </div>
        </ContentMaxWidth>
    </footer>
</template>

<style lang="scss" scoped>
.Footer {
}
</style>
